import axios from "axios";
import { CONSTANTS } from "./constants";
import apiEndPoints from "./apiEndPoints";
import getAxiosConfig from "@src/utils/getAxiosConfig";

export const createOrderPostService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.CREATE_ORDER_POST]?.method,
      apiEndPoints[CONSTANTS.CREATE_ORDER_POST]?.url,
      payload,
      null,
      null,
      null,
      { "Api-Version": payload?.apiVersion }
    ),
  });
};

export const createNewOrderPostService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.CREATE_ORDER_POST_DYNAMIC_BUNDLING]?.method,
      apiEndPoints[CONSTANTS.CREATE_ORDER_POST_DYNAMIC_BUNDLING]?.url,
      payload,
      null,
      null,
      null,
      { "Api-Version": payload?.apiVersion }
    ),
  });
};

export const captureInterestPostService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.CREATE_CAPTURE_INTEREST]?.method,
      apiEndPoints[CONSTANTS.CREATE_CAPTURE_INTEREST]?.url,
      payload,
      null,
      null,
      null
    ),
  });
};

export const createCheckoutGetService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.PAYMENT_CHECKOUT_GET]?.method,
      apiEndPoints[CONSTANTS.PAYMENT_CHECKOUT_GET]?.url,
      payload
    ),
  });
};

export const checkPaymentStatusGetService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.CHECK_PAYMENT_STATUS_GET]?.method,
      apiEndPoints[CONSTANTS.CHECK_PAYMENT_STATUS_GET]?.url,
      payload
    ),
  });
};

export const addToCartService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.ADD_TO_CART_POST]?.method,
      apiEndPoints[CONSTANTS.ADD_TO_CART_POST]?.url,
      payload
    ),
  });
};

export const getSignedPayloadService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.GET_SIGNED_PAYLOAD_GET]?.method,
      apiEndPoints[CONSTANTS.GET_SIGNED_PAYLOAD_GET]?.url,
      payload
    ),
  });
};

export const getPaymentMethodsService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.PAYMENT_METHODS_GET]?.method,
      apiEndPoints[CONSTANTS.PAYMENT_METHODS_GET]?.url,
      payload
    ),
  });
};
